/* =====================================================================
   Shop the look · popup de productos
   ---------------------------------------------------------------------
   Delegación a nivel de documento: da igual cuántas secciones pinten
   popups en la página, este archivo se carga y se enlaza una sola vez.

   Los textos traducidos viajan en data-stlm-strings de cada <dialog>,
   porque este archivo es un asset estático y no puede usar el filtro | t.
   ===================================================================== */
(function () {
  if (window.__stlmBound) return;
  window.__stlmBound = true;

  var FALLBACK = {
    add: 'Add to cart',
    adding: 'Adding...',
    added: 'Added!',
    addAll: 'Add full look',
    error: "We couldn't add it. Please try again."
  };

  var lastFocused = null;

  function stringsFor(modal) {
    if (!modal) return FALLBACK;
    if (modal.__stlmStrings) return modal.__stlmStrings;
    var parsed = FALLBACK;
    try {
      var raw = modal.getAttribute('data-stlm-strings');
      if (raw) {
        var data = JSON.parse(raw);
        parsed = {
          add: data.add || FALLBACK.add,
          adding: data.adding || FALLBACK.adding,
          added: data.added || FALLBACK.added,
          addAll: data.addAll || FALLBACK.addAll,
          error: data.error || FALLBACK.error
        };
      }
    } catch (e) {
      parsed = FALLBACK;
    }
    modal.__stlmStrings = parsed;
    return parsed;
  }

  function cartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'cart/add.js';
  }

  function addToCart(items) {
    return fetch(cartUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart-add-failed');
      return response.json();
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return data;
    });
  }

  function variantIdFor(item) {
    var field = item.querySelector('[data-stlm-variant]');
    return field && field.value ? Number(field.value) : null;
  }

  function setFeedback(modal, message) {
    if (!modal) return;
    var node = modal.querySelector('[data-stlm-feedback]');
    if (node) node.textContent = message || '';
  }

  /* —— Apertura / cierre ——
     showModal() mete el diálogo en el top layer y el navegador se encarga
     del foco atrapado y de la tecla Escape. */
  function restore() {
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
    lastFocused = null;
  }

  function open(modal, trigger) {
    lastFocused = trigger || document.activeElement;
    setFeedback(modal, '');

    if (typeof modal.showModal === 'function') {
      /* 'close' no burbujea: se escucha en el propio diálogo. Cubre Escape. */
      modal.addEventListener('close', restore, { once: true });
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', ''); /* Sin <dialog>: abre igual, sin top layer. */
    }

    document.body.style.overflow = 'hidden';
    var target = modal.querySelector('[data-stlm-close]:not(.stlm__overlay)') || modal;
    if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
  }

  function close(modal) {
    if (!modal) return;
    if (typeof modal.close === 'function') {
      if (modal.open) modal.close(); /* dispara 'close' → restore() */
      else restore();
    } else {
      modal.removeAttribute('open');
      restore();
    }
  }

  /* —— Añadir individual —— */
  function handleAdd(button) {
    var item = button.closest('[data-stlm-product]');
    var modal = button.closest('.stlm');
    var strings = stringsFor(modal);
    var id = item && variantIdFor(item);
    if (!id) return;

    var label = button.querySelector('span');
    button.disabled = true;
    if (label) label.textContent = strings.adding;

    addToCart([{ id: id, quantity: 1 }]).then(function () {
      if (label) label.textContent = strings.added;
      setFeedback(modal, '');
      setTimeout(function () {
        button.disabled = false;
        if (label) label.textContent = strings.add;
      }, 1600);
    }).catch(function () {
      button.disabled = false;
      if (label) label.textContent = strings.add;
      setFeedback(modal, strings.error);
    });
  }

  /* —— Añadir todo: una sola petición con items[] ——
     Solo productos disponibles: /cart/add.js rechaza el lote entero si uno falla. */
  function handleAddAll(button) {
    var modal = button.closest('.stlm');
    if (!modal) return;
    var strings = stringsFor(modal);

    var items = Array.prototype.slice
      .call(modal.querySelectorAll('[data-stlm-product][data-stlm-available="true"]'))
      .map(function (item) {
        var id = variantIdFor(item);
        return id ? { id: id, quantity: 1 } : null;
      })
      .filter(Boolean);

    if (!items.length) return;

    var label = button.querySelector('span');
    button.disabled = true;
    if (label) label.textContent = strings.adding;
    setFeedback(modal, '');

    addToCart(items).then(function () {
      if (label) label.textContent = strings.added;
      setTimeout(function () {
        close(modal);
        document.dispatchEvent(new CustomEvent('cart:open'));
        button.disabled = false;
        if (label) label.textContent = strings.addAll;
      }, 800);
    }).catch(function () {
      button.disabled = false;
      if (label) label.textContent = strings.addAll;
      setFeedback(modal, strings.error);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-stlm-open]');
    if (opener) {
      var modal = document.getElementById(opener.getAttribute('data-stlm-open'));
      if (modal) {
        event.preventDefault();
        open(modal, opener);
      }
      return;
    }

    var closer = target.closest('[data-stlm-close]');
    if (closer) {
      close(closer.closest('.stlm'));
      return;
    }

    var addAll = target.closest('[data-stlm-add-all]');
    if (addAll) {
      handleAddAll(addAll);
      return;
    }

    var add = target.closest('[data-stlm-add]');
    if (add) handleAdd(add);
  });
})();
